import { Typography } from '@sonnen/web-ui';
import { ReactNode } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { PriceTag } from '../PriceTag/PriceTag';
import styles from './DefaultCtaContent.module.css';

type DefaultCtaContentProps = {
  value: number;
  dataTestId?: string;
  subText?: ReactNode;
};

export const DefaultCtaContent = ({ value, dataTestId, subText }: DefaultCtaContentProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid={dataTestId || 'default-cta-content'}>
      <div className={styles.text}>
        <Typography.Body1>{t('offer.summaryCardTitle')}</Typography.Body1>
        <span>
          <PriceTag value={value} size="Number2" />
        </span>
      </div>
      {subText}
    </div>
  );
};
